var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "micro-container", attrs: { id: "subapp-viewport" } },
    [
      _c(
        "el-row",
        [
          _vm.$root.microError
            ? _c(
                "el-col",
                { attrs: { sm: 24, lg: 24 } },
                [
                  _c(
                    "el-result",
                    {
                      attrs: {
                        icon: "error",
                        title: "遇到错误",
                        subTitle: _vm.$root.microError,
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "extra" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "medium" },
                              on: {
                                click: function ($event) {
                                  return _vm.reload()
                                },
                              },
                            },
                            [_vm._v("刷新页面")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm.$root.microLoading
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _vm._v(" Loading... "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }